import React, { useEffect, useState } from "react";
import { X, Sparkles } from "lucide-react";
import { Link } from "@/lib/router-compat";

const DISMISS_KEY = "scarcity-banner-dismissed-q4-2026";

/**
 * Banner premium de escasez controlada. Se ancla en la parte superior y
 * comunica el cierre de plazas trimestrales. Persiste el dismiss en localStorage.
 */
export const ScarcityBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const dismissed = window.localStorage.getItem(DISMISS_KEY);
    if (!dismissed) setVisible(true);
  }, []);

  const handleDismiss = () => {
    setVisible(false);
    try {
      window.localStorage.setItem(DISMISS_KEY, "1");
    } catch {
      /* ignore quota errors */
    }
  };

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="Disponibilidad de plazas premium"
      className="relative z-50 w-full border-b border-premium-gold/30 bg-gradient-to-r from-background via-card to-background"
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between gap-3 py-2 text-xs md:text-sm">
          <div className="flex items-center gap-2 min-w-0">
            <Sparkles className="w-3.5 h-3.5 shrink-0 text-premium-gold" aria-hidden="true" />
            <p className="truncate text-foreground/90">
              <span className="font-bold text-premium-gold">Tu empresa puede dominar Q4 2026</span>
              <span className="hidden sm:inline"> · Diagnóstico personalizado de tu posición en Google e IA · descubre tu potencial antes que tu competencia</span>
              <span className="sm:hidden"> · Diagnóstico personalizado</span>
            </p>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <Link
              to="/agenda-consultoria"
              className="hidden md:inline-block font-bold text-premium-gold hover:underline whitespace-nowrap"
            >
              Solicitar diagnóstico →
            </Link>
            <button
              type="button"
              onClick={handleDismiss}
              aria-label="Cerrar aviso de plazas"
              className="p-1 rounded-sm hover:bg-foreground/10 transition-colors"
            >
              <X className="w-3.5 h-3.5 text-foreground/70" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
